import { Share } from 'react-native';

/**
 * Generates a formatted share string based on the player's results.
 * Each block represents a layer's score.
 * Green > 90%, Yellow > 60%, Red < 60%
 */
export const generateShareString = (
  puzzleNumber: number,
  averageScore: number,
  timeString: string,
  layerScores: number[]
): string => {
  let blockString = '';

  layerScores.forEach((score, index) => {
    if (score > 90) blockString += '🟩';
    else if (score > 60) blockString += '🟨';
    else blockString += '🟥';

    if ((index + 1) % 4 === 0) blockString += '\n';
  });

  return `piclo.art #${puzzleNumber}\n${Math.round(averageScore)}%\n${timeString}\n\n${blockString.trim()}`;
};

export const shareResults = async (shareText: string) => {
  try {
    await Share.share({
      message: shareText,
    });
  } catch (error) {
    console.error('Failed to share results:', error);
  }
};
